<style scoped>
    @import url("../../styles/smartControl/smartControl.scss");
</style>

<template>
    <div class="box_smartControl" v-if="!$store.state.flagMenuSup">

        <div v-if="flagLoadingCA"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="rgb(247,215,46)"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="menuSup" v-if="$store.state.sistemaSC != ''">{{ $store.state.sistemaSC }}</div>
        <v-icon class="menuSup" :style="{'width':'100%'}" v-else>mdi-cloud-outline</v-icon>

        <div class="painelMain">

            <!-- MENU LATERAL -->
            <MenuLateralDashV2 v-if="!flagLoadingCA"/>

            <!-- PAINEL EXIBIDOR -->
            <div class="painelExibidor" :style="{'width':$store.state.widthDinamCA}" v-if="$store.state.flagExib && !flagLoadingCA">

                <router-view></router-view>

            </div>

        </div>

    </div>
</template>

<script>
//import axios from 'axios'

import MenuLateralDashV2 from './MenuLateralDashV2'

export default {

    components:{
        MenuLateralDashV2,
    },

    data() {
        return {
            //
            flagLoadingCA:true, // desabilitar Loading depois de carregar as info da page.
            //
            //flagExib:true, // init versão large (state)
            // this.$store.state.widthDinamCA
            //widthDinam:'75%', // init versão large com menu aberto. Na versão small o menu é width=100% sempre.

            //
            strFlagMenuOpenItem:'Geral', // controle do item selecionado na página, pelo menu lateral.

        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        // -- STORAGE
        var creden = JSON.parse(localStorage.getItem('creden'))
        var contentUser = JSON.parse(localStorage.getItem('contentUser'))
        let tox = JSON.parse(localStorage.getItem('tokenx'))
        let sistemaSC = JSON.parse(localStorage.getItem('sistemaSC'))
        //let decisorSC = JSON.parse(localStorage.getItem('decisorSC'))
        let culturaSC = JSON.parse(localStorage.getItem('culturaSC'))
        let prodSC = JSON.parse(localStorage.getItem('prodSC'))

        let tamLiAtuadoresSC = JSON.parse(localStorage.getItem('tamLiAtuadoresSC')) // 23/10/2025
        let tamLiSensoresSC = JSON.parse(localStorage.getItem('tamLiSensoresSC')) // 23/10/2025

        const fusoHorarioSC = JSON.parse(localStorage.getItem('fusoHorarioSC')) // 02/05/2026
        
        // -- from storage
        if (creden != null) {
            this.$store.state.flagLogadoDash = creden.flagLogadoDash
            this.$store.state.contentUser = contentUser
            this.$store.state.tox = tox
        }

        // -- from storage
        this.$store.state.emailCliente = contentUser['email']

        // -- from storage
        if (sistemaSC != null) { this.$store.state.sistemaSC = sistemaSC } 
        else { this.$store.state.sistemaSC = '' }

        // -- from storage
        //if (decisorSC != null) { this.$store.state.decisorSC = decisorSC } 
        //else { this.$store.state.decisorSC = '' }

        // -- from storage
        if (prodSC != null) { this.$store.state.prodSC = prodSC} 
        else { this.$store.state.prodSC = '' }

        // -- from storage
        if (culturaSC != null) { this.$store.state.culturaSC = culturaSC } 
        else { this.$store.state.culturaSC = '' }

        // -- from storage
        //if (liAtuadoresSC != null) { this.$store.state.liAtuadoresSC = liAtuadoresSC } 
        //else { this.$store.state.liAtuadoresSC = '' }
        if (tamLiAtuadoresSC != null) { this.$store.state.tamLiAtuadoresSC = tamLiAtuadoresSC } 

        // -- from storage
        //if (liSensoresSC != null) { this.$store.state.liSensoresSC = liSensoresSC } 
        //else { this.$store.state.liSensoresSC = '' }
        if (tamLiSensoresSC != null) { this.$store.state.tamLiSensoresSC = tamLiSensoresSC }

        // -- from storage | 02/05/2026
        if (fusoHorarioSC != null) { this.$store.state.fusoHorarioSC = fusoHorarioSC } // local update
        else { this.$store.state.fusoHorarioSC = 'Europe/Lisbon' } // default

        if (this.$store.state.flagLogadoDash == true) { // última alteração 07/10/2024

            this.$store.state.LarguraPageCA = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            var self = this

            // AQUI DEVEM SER INICIALIZADAS AS HIERARQUIAS DE MALHAS, GRUPOS E CONTADORES. 20/01/2025
            self.flagLoadingCA = false // tmp enquanto nao ha axios. 20/01/2025

        } else {

            // -- reencaminhar para login.
            this.$router.push('/dashmain')
            return
        }
    }
}
</script>